"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isHexCode = exports.isCoord = exports.isRgb = exports.CarriageReturnMode = exports.IndexMode = void 0;
var IndexMode;
(function (IndexMode) {
    IndexMode[IndexMode["TopLeft"] = 0] = "TopLeft";
    IndexMode[IndexMode["TopRight"] = 1] = "TopRight";
})(IndexMode = exports.IndexMode || (exports.IndexMode = {}));
var CarriageReturnMode;
(function (CarriageReturnMode) {
    CarriageReturnMode[CarriageReturnMode["Regular"] = 0] = "Regular";
    CarriageReturnMode[CarriageReturnMode["Snaked"] = 1] = "Snaked";
})(CarriageReturnMode = exports.CarriageReturnMode || (exports.CarriageReturnMode = {}));
function isRgb(color) {
    return color.r !== undefined
        && color.g !== undefined
        && color.b !== undefined;
}
exports.isRgb = isRgb;
function isCoord(object) {
    return object.x !== undefined
        && object.y !== undefined;
}
exports.isCoord = isCoord;
function isHexCode(color) {
    return typeof color === "string" && color.startsWith("#");
}
exports.isHexCode = isHexCode;
//# sourceMappingURL=types.js.map